module.exports = __webpack_public_path__ + "img/s-hd.aae7f05b.jpg";